var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWord = function SvgWord(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 23,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Word_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#41A5EE",
    d: "M22.977 0H6.605C6.04 0 5.582.458 5.582 1.023v4.56l9.488 2.79L24 5.584v-4.56C24 .458 23.542 0 22.977 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2B7CD3",
    d: "M24 5.583H5.582v5.582l9.488 1.675L24 11.165z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185ABD",
    d: "M5.582 11.165v5.583l8.93 1.116L24 16.747v-5.582z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103F91",
    d: "M6.605 22.33h16.372c.565 0 1.023-.458 1.023-1.023v-4.56H5.582v4.56c0 .565.458 1.023 1.023 1.023"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M12.372 4.466h-6.79v13.956h6.79a1.027 1.027 0 0 0 1.024-1.023V5.489a1.027 1.027 0 0 0-1.024-1.023",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M11.814 5.024H5.582v13.957h6.232a1.027 1.027 0 0 0 1.023-1.024V6.047a1.027 1.027 0 0 0-1.023-1.023",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M11.814 5.024H5.582v12.84h6.232a1.027 1.027 0 0 0 1.023-1.023V6.048a1.027 1.027 0 0 0-1.023-1.024",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M11.256 5.024H5.582v12.84h5.674a1.027 1.027 0 0 0 1.023-1.023V6.048a1.027 1.027 0 0 0-1.023-1.024",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Word_svg__b)",
    d: "M1.023 5.024h10.233c.565 0 1.023.458 1.023 1.024v10.235c0 .565-.458 1.023-1.023 1.023H1.023A1.023 1.023 0 0 1 0 16.282V6.048c0-.566.458-1.024 1.023-1.024"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4.198 12.872q.03.237.04.413h.023q.014-.167.056-.403t.077-.4L5.47 7.84H6.86l1.116 4.574q.098.426.14.863h.018q.031-.423.116-.838l.89-4.601h1.267L8.844 14.49h-1.48l-1.06-4.407a10 10 0 0 1-.177-.943H6.11q-.02.163-.072.483-.054.319-.086.473l-.997 4.393H3.449L1.877 7.839h1.29l.969 4.653q.033.143.062.38"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Word_svg__b",
    x1: 2.133,
    x2: 10.148,
    y1: 4.225,
    y2: 18.104,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2368C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#1A5DBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1146AC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Word_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v22.33H0z"
  })))));
};
export default SvgWord;